import { createStyles, makeStyles } from '@mui//styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    errorMessage: {
      marginTop: '12px !important',
    },
  }),
);
